// frontend/src/api/apiBase.ts

// Runtime-configured API base (injected via /env.js by nginx at container start)
// Fallbacks:
//  1) window.__ENV__.API_BASE_URL (staging/prod)
//  2) REACT_APP_API_BASE (local dev without nginx)
//  3) localhost default

declare global {
  interface Window {
    __ENV__?: Record<string, string>;
  }
}

export const API_BASE =
  window.__ENV__?.API_BASE_URL ||
  process.env.REACT_APP_API_BASE ||
  "http://localhost:8000";